import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoginService } from './login.service';

/**
 * Interfaz para los datos del formulario de contacto
 */
interface ContactFormData {
    name: string;
    email: string;
    subject: string;
    message: string;
    [key: string]: string; // Para campos adicionales
}

@Injectable({
    providedIn: 'root'
})
export class ContactService {
    private apiUrl: string;

    constructor(
        private http: HttpClient,
        private loginService: LoginService
    ) {
        this.apiUrl = environment.API_BACK;
    }

    private getLang(): string {
        return sessionStorage.getItem('lang') || 'es';
    }

    private handleError(error: HttpErrorResponse) {
        console.error('[ContactService] Error en la petición:', error);

        if (error.status === 401) {
            this.loginService.logout();
            return throwError(() => new Error('Sesión expirada o inválida'));
        }

        return throwError(() => new Error(error.message || 'Error en el servidor'));
    }

    /**
     * Envía un correo de contacto
     * @param data Datos del formulario de contacto
     * @returns Observable con la respuesta del servidor
     */
    public sendEmailContact(data: ContactFormData): Observable<any> {
        console.debug('[ContactService] Enviando email de contacto:', data);
        const url = `${this.apiUrl}email/send?lang=${this.getLang()}`;

        // Crear headers específicos para form-urlencoded
        const headers = this.loginService.getHeaders(true)
            .set('Content-Type', 'application/x-www-form-urlencoded');

        // Convertir datos a formato form-urlencoded
        const formData = Object.keys(data)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
            .join('&');

        return this.http.post(url, formData, { headers }).pipe(
            map(response => {
                console.debug('[ContactService] Respuesta envío email:', response);
                return response;
            }),
            catchError(error => this.handleError(error))
        );
    }
}
